/* ----------------------------------------
    Node Modules
---------------------------------------- */

import anime from 'animejs';

/* ----------------------------------------
    Modules
---------------------------------------- */

import { Overlay } from '@js/module/Overlay';
const overlay = new Overlay(1000);

/* ----------------------------------------
    Animations
---------------------------------------- */

const openMenu = el => {
    console.log(el);

    anime({
        targets: el,
        translateY: ['-100%', '0%'],
        easing: 'easeInOutExpo',
        duration: 1000,
        begin: () => {
            overlay.createOverlay();
            document.body.style.overflow = 'hidden';
            el.style.display = 'flex';
        }
    });
};

const closeMenu = el => anime({
    targets: el,
    translateY: ['0%', '-100%'],
    easing: 'easeInOutExpo',
    duration: 800,
    complete: () => {
        overlay.removeOverlay();
        document.body.style.overflow = 'auto';
        el.style.display = 'none';
    }
});

/* ----------------------------------------
    Mobile Menu
---------------------------------------- */

export class MenuNavigation {

    constructor(init = true) {
        this.active = false;
        this.switch = false;
        this._custom = null;
        this._init(init);
    }

    /** ----------------------------------------
         Open & Close
     ---------------------------------------- */

    _open() {
        this._setState(true);
        openMenu(this._menu);
    }

    _close() {
        this._setState(false);
        closeMenu(this._menu);
    }

    close() {
        if(this.active) {
            this.active = !this.active;
            this._close();
        }
    }

    /** ----------------------------------------
         State Toggle
     ---------------------------------------- */

    _setState(bool) {
        const hamburger = this._hamburger;
        const icon = this._hamburger.querySelector('.hamburger');
        const type = bool ? 'add' : 'remove';
        icon.classList[type]('is-active');
    }

    /** ----------------------------------------
        Switch Toggle
     ---------------------------------------- */

    _setSwitch(bool) {
        const toggle = this._switch;
        const type = bool ? 'add' : 'remove';
        toggle.classList[type]('is-active');
        this.switch = !this.switch;
    }

    /** ----------------------------------------
         Toggle Events
     ---------------------------------------- */

    _toggleEvent(e) {
        e.preventDefault();
        console.log(this._menu);
        this.active = !this.active;
        this.active ? this._open() : this._close();
    }

    /** ----------------------------------------
        Events
     ---------------------------------------- */

    _event() {
        [...this._toggle].forEach(event => {
            event.addEventListener('click', this._toggleEvent.bind(this), false);
        });

        this._switch.addEventListener('click', () => {
            this.switch ? this._setSwitch(false) : this._setSwitch(true);
        });
    }

    /** ----------------------------------------
         Custom Events
     ---------------------------------------- */

    addToggleEvent(el) {
        this._hamburger = el;
        this._menu = document.querySelector('#js-menu');
        this._hamburger.addEventListener('click', this._toggleEvent.bind(this), false);
    }

    destroyToggleEvent() {
        this._hamburger.removeEventListener('click', this._toggleEvent, false);
    }

    /** ----------------------------------------
         Initialize
     ---------------------------------------- */

    _init(init) {
        this._menu = document.querySelector('#js-menu');
        this._hamburger = document.querySelector('#js-hamburger');
        this._toggle = document.querySelectorAll('[data-toggle-menu]');
        this._switch = document.querySelector('#js-switch');

        init && this._event();
    }

}
